import { AirConditionerIcon } from './AirConditionerIcon';

/**
 * author: Simran
 * id FACEA69B-49F0-4588-BDEC-693965AD4649
 * name air-conditioner
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/air-conditioner.svg
 * tags
 * - Home Automation 
 * - Automotive 
 */
export const AcUnitIcon = AirConditionerIcon;
export default AcUnitIcon